import React from "react";
import styled from "styled-components";
import { H3 } from "./Headers";
import { Grid, CardMedia, Card, CardContent } from "@material-ui/core";
import getUrl from "../functions/getUrl";
import BlockQuote from "./BlockQuote";

const CardGrid = styled(Grid)`
  width: 100%;
`;

const CardImg = styled(CardMedia)`
  height: 140px;
`;

const StyledCard = styled(Card)`
  width: 100%;
`;

const Title = styled(H3)`
  margin-top: 10px;
  font-size: 18px;
  font-weight: 800;
`;

const StartupBar = () => {
  return (
    <CardGrid container justify="center" alignItems="center">
      <Grid item>
        <StyledCard>
          <Title center>I'm a Partner, Now What?</Title>
          <CardImg image={getUrl("/static/img/Partnership.png")} title="Partners shaking hands" />
          <CardContent>
            <BlockQuote>
              <p>View our API Documentation</p>
              <p>Download the Qmlativ SDK</p>
              <p>Try out API Endpoints</p>
              <p>Ask a Question</p>
              <p>Obtain a Development Sandbox</p>
            </BlockQuote>
          </CardContent>
        </StyledCard>
      </Grid>
    </CardGrid>
  );
};

export default StartupBar;
